import React from "react";
import { connect } from "react-redux";
import { setError } from "../../redux/slice";

const Error = (Component) => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    const { error } = state.common;
    return {
      error: error,
    };
  }
  return connect(mapStateToProps, { setError })(Container);
};

export default Error;
